export enum InvoiceSendingTypeIntegerEnum {
  NotSet = 0,
  Email = 1,
  Main = 2,
  Reminder1 = 3,
  Reminder2 = 4,
  Card = 5,
  EmailReminder = 6,
  Sms = 7,
  SmsReminder = 8,
}
